import { render, staticRenderFns } from "./payment-form-preloader.vue?vue&type=template&id=0c8aa549&scoped=true"
import script from "./payment-form-preloader.vue?vue&type=script&lang=ts"
export * from "./payment-form-preloader.vue?vue&type=script&lang=ts"
import style0 from "./payment-form-preloader.vue?vue&type=style&index=0&id=0c8aa549&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8aa549",
  null
  
)

export default component.exports